import React from "react";
import StaticPage from "../components/StaticPage";

export default function Investors() {
    return (
        <StaticPage
            kicker="Investors"
            title="Back the ownership layer of global cinema."
            lede="Silver Screen Xchange is building a transparent, legally-structured exchange for film copyright across 50+ countries. If you're interested in the category we're creating — reach out."
            blocks={[
                { eyebrow: "Thesis", title: "A new primary asset class",
                  body: "Film copyright has historically traded in private treaties and opaque distribution paper. Silver Screen Xchange brings it into the open as a registered, transferable instrument — under the Indian Copyright Act, 1957." },
                { eyebrow: "Traction", title: "Vetted supply + verified buyers",
                  body: "Every film is chain-of-title audited; every buyer is KYC & company-verified. Early catalogue spans Bollywood, Hollywood indie, Malayalam drama, Japanese action, French romance." },
                { eyebrow: "Monetisation", title: "Take-rate on each transfer",
                  body: "Silver Screen Xchange earns a structured transaction fee on each exclusive copyright transfer plus SaaS fees for studios maintaining live catalogues on the platform." },
                { eyebrow: "Moat", title: "Legal + trust infrastructure",
                  body: "Standardised assignment deeds, Purchase Agreements, e-sign, escrow, Vault delivery, Transfer Records — investors know that's where marketplaces truly compound." },
            ]}
            cta={{ label: "Request the investor deck", href: "/contact" }}
        />
    );
}
